import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// import { ArticlesComponent } from './articles.component';
import { AuthGuard } from '../../auth/auth-guard.service';
// import { ArticleComponent } from './article.component';
import { SettingsComponent } from './settings.component';
import { SettingPageComponent } from './setting-page/setting-page.component';
import { SettingNetworkComponent } from './setting-network/setting-network.component';
import { SettingMenuComponent } from './setting-menu/setting-menu.component';
import { SettingGeneralComponent } from './setting-general/setting-general.component';
import { SettingStatComponent } from './setting-stat/setting-stat.component';

const routes: Routes = [
  {
    path: '',
    component: SettingsComponent, canActivate: [AuthGuard],
    data: { permissions: ['adminAccess']},
    children: [

      {
        path: 'general',
        component: SettingGeneralComponent,
        canActivate: [AuthGuard],
        data: { permissions: ['adminAccess', 'adminEditSetting']},
        
      },
      {
        path: 'menu',
        component: SettingMenuComponent,
        canActivate: [AuthGuard],
        data: { permissions: ['adminAccess', 'adminEditSetting']},
        
      },
  
      {
        path: 'network',
        component: SettingNetworkComponent,
        canActivate: [AuthGuard],
        data: { permissions: ['adminAccess', 'adminEditSetting']},
        
      },
      {
        path: 'page',
        component: SettingPageComponent,
        canActivate: [AuthGuard],
        data: { permissions: ['adminAccess', 'adminEditSetting']},
        
      },
      {
        path: 'stat',
        component: SettingStatComponent,
        canActivate: [AuthGuard],
        data: { permissions: ['adminAccess', 'adminEditSetting']},
        
      },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SettingRoutingModule { }

export const routedComponents = [
  SettingsComponent,
  SettingStatComponent,
  SettingPageComponent,
  SettingNetworkComponent,
  SettingMenuComponent,
  SettingGeneralComponent,
];
